import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {InsolesTypeFamilySummaryConverter} from '../family/insolesTypeFamilySummary.converter';
import {InsolesTypeSummaryModel} from './insolesTypeSummary.model';

@Injectable()
export class InsolesTypeSummaryConverter extends HttpModelConverter<InsolesTypeSummaryModel> {

    constructor(private insolesTypeFamilySummaryConverter: InsolesTypeFamilySummaryConverter) {
        super();
    }

    protected createInstance(): InsolesTypeSummaryModel {
        return new InsolesTypeSummaryModel();
    }

    protected enrichObject(result: InsolesTypeSummaryModel, src: InsolesTypeSummaryModel) {
        result.family = this.insolesTypeFamilySummaryConverter.convert(src.family);
    }

}
